import { createFileRoute, Outlet } from '@tanstack/react-router'
import { RouteErrorFallback } from '@components/errors/RouteErrorFallback'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

const columnPresetValues = [
    'student-information',
    'in-year-data',
    'student-intervention',
    'custom-columns',
    'all-columns',
] as const

const myFacultySearchSchema = z.object({
    columnPreset: z.enum(columnPresetValues).optional(),
})

export const Route = createFileRoute('/_layout/_teacher-portal/groups')({
    component: Outlet,
    staticData: {
        crumb: {
            label: `Groups`
        }
    },
    validateSearch: zodValidator(myFacultySearchSchema),
    errorComponent: ({ error, reset }) => (
        <RouteErrorFallback
            error={error}
            onRetry={reset}
            title="Uh oh... something went wrong"
            description="An unexpected error occurred while loading groups."
        />
    )
})